<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="isLoading()"
  [totalCount]="totalCount()"
  [clickableRows]="true"
  (rowClick)="onRowClick($event)"
></xemex-table>
